// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import productsReducer from "../features/products/productsSlice";
import userReducer from "../features/user/userSlice";
import authReducer from "../features/auth/authSlice";
import cartReducer from "../features/cart/cartSlice";
import orderReducer from "../features/order/orderSlice";

const appReducer = combineReducers({
  products: productsReducer,
  user: userReducer,
  auth: authReducer,
  cart: cartReducer,
  order: orderReducer,
});

// Beim Logout den gesamten Store zurücksetzen. Verhindert, dass Warenkorb,
// Bestellungen oder Nutzerdaten des vorigen Users beim nächsten Login sichtbar bleiben.
const rootReducer = (state, action) =>
  appReducer(action.type === "auth/logout" ? undefined : state, action);

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
